<template>
  <div class="d-flex flex-column align-items-center h-100">
    <div class="w-100 text-center mb-4">
      <h2 class="my-3">AIRSUSPENSION PRODUCT SCANNER</h2>
    </div>
    <div v-if="loading" class="overlay d-flex justify-content-center align-items-center">
      <b-icon icon="arrow-clockwise" animation="spin" font-scale="4" variant="light"></b-icon>
    </div>
    <div v-if="!found" class="card p-4 mt-5" style="width: 100%; max-width: 400px;">
      <div class="card-body">
        <h1 class="card-title text-center mb-4">
          <b-icon icon="upc-scan"></b-icon>
        </h1>
        <b-form @submit.prevent="handleScan">
          <b-form-group label-for="input-text">
            <b-form-input
              ref="eanInput"
              id="ean-input"
              v-model="ean"
              placeholder="EAN SCANNER"
              required
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </div>
    <div class="kartica" v-else>
      <b-container fluid>
        <b-row class="equal-height-row">
          <b-col cols="6" class="d-flex align-items-center justify-content-center p-3 image-column bg-white">
            <h5>{{ found.name }}</h5>
            <b-img
              v-if="found.images && found.images.length && found.images[0].src"
              :src="found.images[0].src"
              fluid
              alt="Product image"
              class="max-height-image"
            ></b-img>
          </b-col>
          <b-col cols="6" class="p-0 d-flex flex-column table-column bg-dark">
            <div class="table-container flex-grow-1 overflow-auto">
              <b-table
                :items="found.categories"
                head-variant="dark"
                sticky-header="37vh"
                responsive="sm"
                class="mb-0"
              >
              </b-table>
            </div>
            <div class="p-3">
              <b-btn @click="done" class="w-100" variant="success">Done</b-btn>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-card class="text-left mt-3"
        :header="`SKU: ${found.sku}`"
        header-tag="header">
        <b-card-text>
          <div style="float:left">
            <span class="kolicina">{{ found.stock }}</span>
          </div>
          <div style="float:right">
            <b-button size="lg"
                      :disabled=false
                      @click="qtt('-')"
                      class="dugmad"
                      href="#"
                      variant="danger">
              <b-icon-arrow-down></b-icon-arrow-down>
            </b-button>

            <b-button size="lg"
                      :disabled=false
                      @click="qtt('+')"
                      class="dugmad"
                      href="#"
                      variant="success">
              <b-icon-arrow-up></b-icon-arrow-up>
            </b-button>
            <b-button size="lg"
                      :disabled=false
                      @click="setStock"
                      class="dugmad" href="#"
                      variant="success">
              <b-icon-check></b-icon-check>
            </b-button>
          </div>
        </b-card-text>
      </b-card>

      <b-card
        class="mt-3"
        :header="found.location || 'No location'"
        header-tag="header">
        <b-form-select
          v-model="locationSelected.raf"
          :options="rafe"></b-form-select>
        <b-form-select
          class="mt-3"
          v-model="locationSelected.kolona"
          :options="kolone"></b-form-select>
        <b-form-select
          class="mt-3"
          v-model="locationSelected.red"
          :options="redovi"></b-form-select>
        <b-form-select
          class="mt-3"
          v-model="locationSelected.box"
          :options="boxovi"></b-form-select>
        <b-button size="lg"
                  style="float:right"
                  @click="saveLocation"
                  class="dugmad" href="#"
                  variant="success">
          <b-icon-check></b-icon-check>
        </b-button>
      </b-card>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import fixed from '@/fixed';

export default {
  name: 'EanScan',
  data() {
    return {
      loading: false,
      ean: '',
      found: null,
      lok: {
        id: 0,
        location: 'LOCATION',
      },
      rafe: fixed.locations.rafe,
      kolone: fixed.locations.kolone,
      redovi: fixed.locations.redovi,
      boxovi: [
        { value: null, text: 'Select box (optional)' },
      ],
      locationSelected: {
        raf: '',
        kolona: '',
        red: '',
        box: '',
      },
    };
  },
  created() {
    this.populateBoxes();
    this.focusEanInput();
  },
  methods: {
    async handleScan() {
      if (!this.ean) return;

      const uri = `${fixed.API_URL}/admin/as-ean2products?ean=${this.ean}`;
      try {
        this.loading = true;
        const { data } = await axios.get(uri, { withCredentials: true });
        const [first] = data || [];

        if (!first) {
          this.$toast.info('No article with that code');
        } else {
          this.found = {
            id: first.id,
            name: first.name,
            images: first.images,
            categories: first.categories,
            sku: first.sku,
            stock: first.stock_quantity,
            location: this.locationFromMeta(first.meta_data),
          };

          // Location parsing
          const opcije = this.found.location ? this.found.location.split(' ') : '';
          if (opcije.length >= 1) {
            const [raf, kolona, red, box] = opcije;
            // eslint-disable-next-line object-curly-newline
            this.locationSelected = { raf, kolona, red, box };
          } else {
            this.locationSelected = {
              raf: '',
              kolona: '',
              red: '',
              box: '',
            };
          }
        }
      } catch (err) {
        this.$toast.error('Error while setting location!');
      }

      this.loading = false;
      this.ean = '';
    },
    async setStock() {
      if (!this.found.id || this.found.stock < 0) return;
      this.loading = true;
      try {
        const payload = { id: this.found.id, stock: this.found.stock };
        await axios.put(`${fixed.API_URL}/admin/as-set-stock`, payload, { withCredentials: true });
        this.$toast.success('Product stock updated successfully!');
      } catch (err) {
        this.$toast.error('Error updating stock');
      }
      this.loading = false;
    },
    async saveLocation() {
      if (!this.locationSelected.raf || !this.locationSelected.kolona || !this.locationSelected.red) return; // eslint-disable-line

      const cleanBox = !this.locationSelected.box || this.locationSelected.box === ' ' || this.locationSelected.box === 'undefined' || this.locationSelected.box === 'null' ? '' : this.locationSelected.box;
      this.lok.location = `${this.locationSelected.raf} ${this.locationSelected.kolona} ${this.locationSelected.red} ${cleanBox}`;
      this.lok.id = this.found.id;

      const url = `${fixed.API_URL}/admin/as-set-location`;
      this.loading = true;
      try {
        await axios.put(url, this.lok, { withCredentials: true });
        this.$toast.success('Saved successfully');
      } catch (error) {
        this.error = error;
      }
      this.found.location = this.lok.location;
      this.loading = false;
    },
    qtt(operator) {
      if (operator === '-' && this.found.stock < 1) return;

      if (operator === '+') {
        this.found.stock += 1;
      } else {
        this.found.stock -= 1;
      }
    },
    locationFromMeta(meta) {
      const locationMeta = meta.find((m) => m.key === '_location');
      return locationMeta ? locationMeta.value : '';
    },
    populateBoxes() {
      for (let i = 1; i <= 200; i += 1) {
        this.boxovi.push({ value: `Box${i}`, text: `Box ${i}` });
      }
    },
    done() {
      this.found = null;
      this.focusEanInput();
    },
    focusEanInput() {
      this.$nextTick(() => {
        if (this.$refs.eanInput) {
          this.$refs.eanInput.focus();
        }
      });
    },
  },
};
</script>
<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6); /* dark semi-transparent */
  z-index: 9999;
}
</style>
